/**
 * Conflits de synchronisation qui attendent un arbitrage, pour qui peut les
 * trancher : la rubrique « Conflits », sa tuile du Menu et l'indicateur de
 * synchronisation lisent le même total (une seule requête, une page d'un
 * élément). Rien n'est demandé en vue Terrain ni sans le droit d'arbitrer.
 */
import { useQuery } from '@tanstack/react-query';
import type { CursorPage } from '@myequip/shared';
import { api } from '../../core/api.js';
import { useAuth, useCan, useTerrainView } from '../../core/auth.js';

export const CONFLICTS_PATH = '/conflits';
/** Envois en attente de l'appareil, ouverts depuis l'indicateur de synchronisation. */
export const SYNC_QUEUE_PATH = '/synchronisation';

export function useOpenConflicts(): { arbitrate: boolean; total: number | undefined } {
  const { me } = useAuth();
  const can = useCan();
  const terrain = useTerrainView();
  const arbitrate = Boolean(me) && !terrain && can('conflict.arbitrate');
  const query = useQuery({
    queryKey: ['sync-conflicts', me?.id, 'total'],
    queryFn: () => api<CursorPage<{ id: string }>>('/sync/conflicts?paged=1&limit=1'),
    enabled: arbitrate,
    refetchInterval: 60_000,
    retry: false,
  });
  return { arbitrate, total: arbitrate ? query.data?.total : 0 };
}
